import React from "react";
import useTranslation from "@hooks/use_translation";
import { cn } from "@/lib/utils";
import IdentityVerificationLogo from "@/components/ui/identity_verification_logo";
import { identityVerificationPartnerConfig } from "@/utils/identity_verification_provider";

interface IdentityVerificationButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  partner?: string | null;
}

const IdentityVerificationButton: React.FC<IdentityVerificationButtonProps> = ({
  className = "",
  disabled,
  onClick,
  partner,
  style,
  ...props
}) => {
  const { t } = useTranslation("identity_verification");
  const partnerConfig = identityVerificationPartnerConfig(partner);
  const baseClasses =
    "bg-white relative rounded-full border border-black border-solid flex items-center justify-center gap-2 min-w-[180px] !px-8 !py-2 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed";

  const combinedClassName = cn(baseClasses, className);

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={combinedClassName}
      style={{ fontFamily: "'Inter', sans-serif", ...style }}
      {...props}
    >
      {partnerConfig.partner && (
        <div className="h-6 w-6 shrink-0 flex items-center justify-center">
          <IdentityVerificationLogo partner={partner} variant="icon" decorative />
        </div>
      )}
      <div className="flex items-center text-black whitespace-nowrap">
        <span className="text-[14px] font-normal">
          {t("cta.verify_with_provider", { provider_name: partnerConfig.name })}
        </span>
      </div>
    </button>
  );
};

export default IdentityVerificationButton;
